// @flow
import { connect } from 'react-redux';

import RencontreGeneral, { type StateProps } from 'components/rencontre/RencontreGeneral';

import type { StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  rencontre: state.rencontreState.rencontre,
  rencontresLive: state.rencontreLiveState.rencontres,
});

export default connect(mapStateToProps)(RencontreGeneral);
